import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import ExpedientDetail from './ExpedientDetail';

// Ruta directa a un Expedient de Taller (/taller/expedients/:id, o
// /taller/expedients/new per crear-ne un) — abans nomes es podia arribar a
// ExpedientDetail fent clic dins del llistat d'Expedients.tsx (estat local,
// sense URL pròpia). Permet enllaçar-hi des d'altres mòduls i refrescar la
// pàgina sense perdre la vista.
export default function ExpedientDetailPage() {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  return (
    <ExpedientDetail
      projectId={id}
      initialEdit={searchParams.get('edit') === '1'}
      onBack={() => navigate('/taller')}
    />
  );
}
